export default __webpack_public_path__ + "static/media/element_92.79819d8e.webp";